import React, { Dispatch, SetStateAction } from "react";
import { Popup } from "react-map-gl";
import { MappedPropertyPoint } from "./MapUpMd";
import { formatPrice } from "../../../../helpers/dataConverts";
import { useTranslation } from "react-i18next";
import CrossIconBlue from "../../../../assets/icons/CrossBlueIcon.svg";
import { LikeDemo, LikeSize } from "../../../_shared/LikeDemo";

export const MapPropertyPopup = ({
  selectedPoint,
  setSelectedPoint,
}: {
  selectedPoint: MappedPropertyPoint;
  setSelectedPoint: Dispatch<SetStateAction<MappedPropertyPoint | null>>;
}) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRTL = currentLanguage === "he";

  return (
    <Popup
      latitude={selectedPoint.latitude}
      longitude={selectedPoint.longitude}
      anchor="bottom"
      onClose={() => setSelectedPoint(null)}
      closeOnClick={false}
      closeButton={false}
      maxWidth="322px"
      offset={50}
    >
      <div
        className="map-card-popup-container"
        style={{
          direction: i18n.dir(),
        }}
      >
        <div className="map-card-popup-container-img">
          <div>
            <img
              className="map-card-popup-container-main-img"
              src={selectedPoint.mainImg.url}
              style={{
                position: "relative",
              }}
            />

            <div
              className="map-card-popup-container-main-img-like"
              style={{
                right: isRTL ? "8px" : "auto",
                left: isRTL ? "auto" : "8px",
              }}
            >
              {/* <Like propertyId={selectedPoint.id} /> */}
              <LikeDemo
                propertyId={selectedPoint.id}
                likeSize={LikeSize.SMALL}
                setSelectedPoint={setSelectedPoint}
              />
            </div>
          </div>
        </div>

        <div className="map-card-popup-info-container">
          <div className="map-card-popup-info-price-and-like-container">
            <div className="map-card-popup-container-price">
              {isRTL ? "₪" : "$"}
              {formatPrice(selectedPoint.basePrice)}
            </div>
            <div onClick={() => setSelectedPoint(null)}>
              <img
                src={CrossIconBlue}
                style={{
                  width: "25px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
          <div
            className="map-card-popup-container-name"
            style={{
              letterSpacing: isRTL ? "0.3px" : "",
            }}
          >
            {selectedPoint.title}
          </div>
          <div
            className="map-card-popup-container-location"
            style={{
              letterSpacing: isRTL ? "0.3px" : "",
            }}
          >
            {selectedPoint.location.address}, {selectedPoint.location.city}
          </div>
        </div>
      </div>
    </Popup>
  );
};
